
import respUtility from '~/mixins/respUtility';
import { mapState } from 'vuex';

export default {
  name: 'AllBrandsView',
  mixins: [respUtility],
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState({
      /** @returns {Object} - brands data */
      brands: (state) => state.brands,
    }),
  },
};
